import cx from 'classnames';
import './AllergyChip.css';

const AllergyIcon = (
  <svg
    className='qhs-allergy-chip__icon'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2.5'
    aria-hidden='true'
  >
    <path d='M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z' />
    <line x1='12' y1='9' x2='12' y2='13' />
    <line x1='12' y1='17' x2='12.01' y2='17' />
  </svg>
);

/**
 * QHS AllergyChip
 * ---------------
 * Critical-tinted pill that warns about a patient's drug allergies.
 * Backend currently exposes only `hasDrugAllergies: boolean`; the
 * chip falls back to the generic `genericLabel` text in that case.
 * When/if the backend starts returning allergen names, callers
 * pass `allergens={[...]}` and the chip switches to a specific
 * label like "Drug allergy: Penicillin".
 *
 *   <AllergyChip />                                 // -> Drug Allergies
 *   <AllergyChip allergens={['Penicillin']} />      // -> Drug allergy: Penicillin
 *   <AllergyChip allergens={['Penicillin','Eggs']}/>// -> Drug allergies: Penicillin, Eggs
 */
const AllergyChip = ({
  allergens,
  genericLabel = 'Drug Allergies',
  specificLabelSingle = 'Drug allergy',
  specificLabelMany = 'Drug allergies',
  className,
  ...rest
}) => {
  let label = genericLabel;
  if (Array.isArray(allergens) && allergens.length > 0) {
    const prefix = allergens.length === 1 ? specificLabelSingle : specificLabelMany;
    label = `${prefix}: ${allergens.join(', ')}`;
  }
  return (
    <span className={cx('qhs-allergy-chip', className)} {...rest}>
      {AllergyIcon}
      {label}
    </span>
  );
};

export default AllergyChip;
